import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { debounce } from 'lodash';
import { Space, Button, Tabs } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import ApiServices from '~services';
import { RangeDateFilter, Selection } from '~components';

import { VendorTable } from './vendor-table';
import { CustomerTable } from './customer-table';

const DEFAULT_QUERIES = {
  DateFrom: moment().startOf('month').format(),
  DateTo: moment().endOf('date').format(),
};

const ReportOutputOfVendor = () => {
  const [loading, setLoading] = useState(false);

  const [filter, setFilter] = useState(DEFAULT_QUERIES);
  ////
  const [partners, setPartners] = useState([]);
  const [partnerSelectedId, setPartnerSelectedId] = useState(null);
  const [partnerSelected, setPartnerSelected] = useState({});

  // new
  const [tabKey, setTabKey] = useState(1);
  console.log({ tabKey });

  const [dataCustomer, setDataCustomer] = useState([]);
  const [dataVendor, setDataVendor] = useState([]);

  const getPartners = async (query = '') => {
    return ApiServices.getPartnerByCompany({ query })
      .then(({ data }) => {
        setPartners(data?.data || []);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getPartners();
  }, []);

  const getData = async (query = DEFAULT_QUERIES, partnerId) => {
    const newQuery = {
      ...query,
      CompanyId: partnerId,
      Export: false,
    };
    setLoading(true);
    try {
      const res = await ApiServices.getReportOutputOfVendor(newQuery);

      if (res?.data?.data?.allCustomers) {
        const customerData = res?.data?.data?.allCustomers?.map((item, index) => {
          item.index = index + 1;

          let countBooking = 0;
          let countBill = 0;

          item?.contByOrderType?.forEach((element) => {
            if (element?.orderType === 'Booking') {
              countBooking += element?.count;
            }
            if (element?.orderType === 'Bill') {
              countBill += element?.count;
            }
          });

          item.countBooking = countBooking;
          item.countBill = countBill;

          return item;
        });

        const vendorData = res?.data?.data?.allVendors?.map((item, index) => {
          item.index = index + 1;

          return item;
        });

        setDataCustomer(customerData || []);
        setDataVendor(vendorData || []);
      }
    } catch (error) {
      console.log('GET data Failed::', error);
    } finally {
      setLoading(false);
    }
  };

  const timeoutGetData = useCallback(
    debounce((newFilter, newPartnerSelectedId) => {
      getData(newFilter, newPartnerSelectedId);
    }, 500),
    []
  );
  useEffect(() => {
    if (partnerSelectedId) {
      timeoutGetData(filter, partnerSelectedId);
    }
  }, [filter, partnerSelectedId]);

  const exportExcelFile = async (query = DEFAULT_QUERIES) => {
    if (!query || loading) return;

    const dateFrom = moment(query?.DateFrom).format('YYYY-MM-DD');
    const dateTo = moment(query?.DateTo).format('YYYY-MM-DD');

    const dataSend = {
      DateFrom: query?.DateFrom && moment(query?.DateFrom).format('YYYY-MM-DD'),
      DateTo: query?.DateTo && moment(query?.DateTo).format('YYYY-MM-DD'),
      Export: true,
      CompanyId: partnerSelectedId,
    };
    setLoading(true);
    try {
      const { data } = await ApiServices.exportReportOutputOfVendor(dataSend);
      if (data) {
        const outputFilename = `San_Luong_${partnerSelected?.code}_ngay_${dateFrom}_den_ngay_${dateTo}.xlsx`;
        // If you want to download file automatically using link attribute.
        const url = URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', outputFilename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        window.TmsNoti?.error('Export thất bại!', 'Không có dữ liệu');
      }
    } catch (err) {
      window.TmsNoti?.error('Export thất bại!');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePartner = (value) => {
    if (!value) {
      setPartnerSelectedId('');
      setPartnerSelected(null);

      return;
    }
    const dataPartner = partners.find((item) => item.id === value);
    setPartnerSelectedId(value);
    setPartnerSelected(dataPartner);
  };

  const onChangeTab = (key) => {
    setTabKey(key);
  };

  return (
    <>
      <h1>BẢNG BÁO CÁO SẢN LƯỢNG XE NGOÀI</h1>
      <div
        style={{
          backgroundColor: 'rgb(234, 238, 243)',
          boxShadow:
            'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
          borderRadius: '10px',
          fontSize: '12px',
          padding: '20px 10px',
          marginTop: '15px',
          marginBottom: '15px',
        }}
      >
        <Space>
          <div>
            <b
              style={{
                marginLeft: '10px',
              }}
            >
              Chọn ngày:
            </b>
            <RangeDateFilter query={filter} onChange={setFilter} allowClear={false} />
          </div>
          <div>
            <b>
              Xe ngoài:{' '}
              {!partnerSelectedId && (
                <i
                  style={{
                    color: 'red',
                    fontSize: '12px',
                  }}
                >
                  Bạn phải chọn xe ngoài
                </i>
              )}
            </b>
            <br />
            <Selection
              status={!partnerSelectedId ? 'error' : ''}
              data={partners}
              placeholder='Xe ngoài'
              fieldValue='name'
              width={400}
              value={partnerSelectedId}
              onChange={handleChangePartner}
              onSearch={getPartners}
            />
          </div>
          <div>
            <br />

            <Button
              type='primary'
              loading={loading}
              icon={<EyeOutlined />}
              style={{ padding: '0px 20px', marginLeft: '10px' }}
              onClick={() => exportExcelFile(filter)}
              disabled={!partnerSelectedId}
            >
              Export Excel
            </Button>
          </div>
        </Space>
      </div>
      <Tabs defaultActiveKey='1' onChange={onChangeTab}>
        <Tabs.TabPane tab='Nhà xe' key='1'>
          <VendorTable data={dataVendor} />
        </Tabs.TabPane>
        <Tabs.TabPane tab='Khách hàng' key='2'>
          <CustomerTable data={dataCustomer} />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export { ReportOutputOfVendor };
